<template>
  <!-- Desktop Header - Glassmorphism Style -->
  <header class="header-desktop d-none d-lg-block">
    <div class="header-container">
      <!-- Logo -->
      <a class="header-logo" @click="navigateToHome">
        <span class="brand-text">Ayvens</span>
      </a>

      <!-- Main Navigation -->
      <nav class="header-nav" v-if="userLogged">
        <!-- Partner Navigation -->
        <template v-if="personType === 'Partner'">
          <a class="nav-item" @click="$router.push('/partner/requests')">
            <FileText :size="20" />
            <span>Solicitudes</span>
          </a>
          <a class="nav-item" @click="$router.push('/partner/repartos')">
            <Route :size="20" />
            <span>Deliveries</span>
          </a>
          <!-- <a class="nav-item" @click="$router.push('/partner/cars')">
            <Car :size="20" />
            <span>Coches</span>
          </a> -->
        </template>

        <!-- User Navigation -->
        <template v-if="personType === 'User'">
          <template v-if="isAyvensRoute">
            <a class="nav-item" @click="$router.push('/ayvens/contracts')">
              <FileText :size="20" />
              <span>Contratos</span>
            </a>
            <a class="nav-item" @click="$router.push('/ayvens/incidents')">
              <AlertTriangle :size="20" />
              <span>Incidencias</span>
            </a>
            <a class="nav-item" @click="$router.push('/ayvens/fines')">
              <CreditCard :size="20" />
              <span>Multas</span>
            </a>
          </template>
          <template v-else>
            <!-- <a class="nav-item" @click="$router.push('/user/requests')">
              <FileText :size="20" />
              <span>Solicitudes</span>
            </a> -->
            <a class="nav-item" @click="$router.push('/my-shipments')">
              <Route :size="20" />
              <span>Envíos</span>
            </a>
            <!-- <a class="nav-item" @click="$router.push('/pets')">
              <Dog :size="20" />
              <span>Mascotas</span>
            </a> -->
          </template>
        </template>

        <!-- Staff Navigation -->
        <template v-if="personType === 'Staff'">
          <template v-if="isAyvensRoute">
            <a class="nav-item" @click="$router.push('/staff/ayvens/contracts')">
              <FileText :size="20" />
              <span>Contratos</span>
            </a>
            <div class="nav-item nav-item-dropdown" @click="toggleStaffActionsDropdown">
              <Clipboard :size="20" />
              <span>Operaciones</span>
              <ChevronDown :size="16" />
              <div v-if="staffActionsDropdownOpen" class="dropdown-panel operations-panel" @click.stop>
                <a class="menu-item" @click.stop="navigateAndClose('/staff/ayvens/incidents')">
                  <AlertTriangle :size="18" />
                  <span>Incidencias</span>
                </a>
                <a class="menu-item" @click.stop="navigateAndClose('/staff/ayvens/maintenance')">
                  <Wrench :size="18" />
                  <span>Mantenimientos</span>
                </a>
                <a class="menu-item" @click.stop="navigateAndClose('/staff/ayvens/return-processes')">
                  <Route :size="18" />
                  <span>Devoluciones</span>
                </a>
              </div>
            </div>
            <a class="nav-item" @click="$router.push('/staff/ayvens/service-partners')">
              <Truck :size="20" />
              <span>Partners</span>
            </a>
          </template>
        </template>
      </nav>

      <!-- Right Actions -->
      <div class="header-actions">

        
        <!-- Notifications -->
        <div class="notification-wrapper" v-if="userLogged">
          <button class="icon-btn notification-btn" @click="toggleNotificationDropdown">
            <Bell :size="20" />
            <span v-if="unreadCount" class="notification-badge">{{ unreadCount }}</span>
          </button>
          
          <!-- Notifications Dropdown -->
          <div v-if="dropdownNotificationOpen" class="dropdown-panel notifications-panel">
            <div class="dropdown-header">
              <h6>Notificaciones</h6>
              <button v-if="notifications.length > 0" @click="markAllAsRead" class="mark-read-btn">
                Marcar todas
              </button>
            </div>
            <div class="notifications-list">
              <div v-if="notifications.length === 0" class="empty-state">
                <BellOff :size="32" />
                <p>No hay notificaciones</p>
              </div>
              <div 
                v-for="notification in sortedNotifications.slice(0, 5)" 
                :key="notification.id" 
                class="notification-item"
                @click="handleNotificationClick(notification)"
              >
                <div class="notification-content">
                  <div class="notification-header">
                    <h6>{{ notification.title }}</h6>
                    <span class="notification-time">{{ timeSince(notification.created_at) }}</span>
                  </div>
                  <p class="notification-body" v-html="formatNotificationBody(notification.body)"></p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- User Menu or Login -->
        <div class="user-menu" v-if="userLogged">
          <button class="user-btn" @click="toggleDropdown">
            <MoreHorizontal :size="20" />
            <div class="user-info">
              <span class="user-type">Más</span>
            </div>
            <ChevronDown :size="16" />
          </button>

          <!-- User Dropdown -->
          <div v-if="dropdownOpen" class="dropdown-panel user-panel">
            <a class="menu-item" v-if="personType !== 'Staff'" @click="$router.push(personType === 'Partner' ? '/partner/info' : '/user/info')">
              <User :size="18" />
              <span>Perfil</span>
            </a>
        <template v-if="personType === 'User' && isAyvensRoute">
              <div class="menu-divider"></div>
              <div class="menu-section-label">Ayvens</div>
              <a class="menu-item" @click="$router.push('/ayvens/return-process')">
                <Route :size="18" />
                <span>Devolución</span>
              </a>
              <a class="menu-item" @click="$router.push('/ayvens/contracts')">
                <FileCheck :size="18" />
                <span>Documentos</span>
              </a>
              <a class="menu-item" @click="$router.push('/ayvens/nps-survey')">
                <Tag :size="18" />
                <span>Opinión NPS</span>
              </a>
            </template>
        <template v-if="personType === 'Staff' && isAyvensRoute">
          <div class="menu-divider"></div>
          <div class="menu-section-label">Ayvens</div>
          <a class="menu-item" @click="$router.push('/staff/ayvens/documents')">
            <FileCheck :size="18" />
            <span>Documentos</span>
          </a>
          <a class="menu-item" @click="$router.push('/staff/ayvens/service-partners')">
            <Clipboard :size="18" />
            <span>Partners</span>
          </a>
          <a class="menu-item" @click="$router.push('/staff/ayvens/metrics')">
            <BarChart :size="18" />
            <span>Métricas</span>
          </a>
        </template>
            <a class="menu-item" v-if="personType === 'Partner'" @click="$router.push('/partner/availability')">
              <Calendar :size="18" />
              <span>Disponibilidad</span>
            </a>
            <a class="menu-item" v-if="personType !== 'Staff'" @click="$router.push(personType === 'Partner' ? '/partner/payments' : '/user/charges')">
              <CreditCard :size="18" />
              <span>Cuenta</span>
            </a>
        <a class="menu-item" v-if="personType === 'Staff' && !isAyvensRoute" @click="$router.push('/staff')">
              <Home :size="18" />
              <span>Dashboard</span>
            </a>
            
            <!-- Sección de Roles (si tiene múltiples) -->
            <template v-if="hasMultipleRoles">
              <div class="menu-divider"></div>
              <div class="menu-section-label">Cambiar Rol</div>
              <a 
                v-for="role in availableRoles" 
                :key="role.type"
                class="menu-item role-item"
                :class="{ 'active': role.type.toLowerCase() === personType.toLowerCase() }"
                @click="role.type.toLowerCase() !== personType.toLowerCase() ? switchToRole(role.type) : null"
              >
                <div class="role-icon-small">
                  <component :is="role.type === 'user' ? 'User' : role.type === 'partner' ? 'Truck' : 'Briefcase'" :size="18" />
                </div>
                <span>{{ role.label }}</span>
                <svg v-if="role.type.toLowerCase() === personType.toLowerCase()" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="check-icon"><polyline points="20 6 9 17 4 12"></polyline></svg>
              </a>
            </template>
            
            <div class="menu-divider"></div>
            <a class="menu-item logout" @click="userlogout()">
              <LogOut :size="18" />
              <span>Cerrar sesión</span>
            </a>
          </div>
        </div>

        <!-- Login/Register Buttons -->
        <div class="auth-buttons" v-else>
          <a class="btn-auth btn-login" href="/login">Entrar</a>
          <a class="btn-auth btn-register" href="/register">Regístrate</a>
        </div>
      </div>
    </div>

    <!-- Marquee Banner -->
    <div class="marquee-banner" v-if="current_travels">
      <div class="marquee">{{ current_travels }}</div>
    </div>
  </header>

  <!-- Mobile Bottom Navigation -->
  <nav class="mobile-nav d-lg-none">
    <!-- Marquee Banner Mobile -->
    <div class="marquee-banner-mobile" v-if="current_travels">
      <div class="marquee">{{ current_travels }}</div>
    </div>

    <div class="mobile-nav-content">
      <!-- Home/Logo -->
      <button class="mobile-nav-item mobile-nav-item-logo" @click="navigateToHome">
        <span class="mobile-nav-logo-text">Ayvens</span>
      </button>

      <!-- Dynamic Navigation Based on User Type -->
      <template v-if="userLogged">
        <!-- Partner Navigation - Simplified -->
        <template v-if="personType === 'Partner'">
          <button class="mobile-nav-item" @click="$router.push('/partner/requests')">
            <FileText :size="22" />
            <span>Solicitudes</span>
          </button>
          <button class="mobile-nav-item" @click="$router.push('/partner/repartos')">
            <Route :size="22" />
            <span>Deliveries</span>
          </button>
          <!-- <button class="mobile-nav-item" @click="$router.push('/partner/cars')">
            <Car :size="22" />
            <span>Coches</span>
          </button>
          <button class="mobile-nav-item" @click="toggleNotificationDropdown">
            <Bell :size="22" />
            <span>Avisos</span>
            <span v-if="unreadCount" class="mobile-badge">{{ unreadCount }}</span>
          </button> -->
          <button class="mobile-nav-item" @click="toggleDropdown">
            <img @error="onImageError" :src="personPhoto" class="mobile-nav-avatar">
            <span>Más</span>
          </button>
        </template>

        <!-- User Navigation -->
        <template v-if="personType === 'User'">
          <template v-if="isAyvensRoute">
            <button class="mobile-nav-item" @click="$router.push('/ayvens/contracts')">
              <FileText :size="22" />
              <span>Contratos</span>
            </button>
            <button class="mobile-nav-item" @click="$router.push('/ayvens/incidents')">
              <AlertTriangle :size="22" />
              <span>Incidencias</span>
            </button>
            <button class="mobile-nav-item" @click="$router.push('/ayvens/fines')">
              <CreditCard :size="22" />
              <span>Multas</span>
            </button>
            <button class="mobile-nav-item" @click="toggleDropdown">
              <MoreHorizontal :size="22" />
              <span>Más</span>
            </button>
          </template>
          <template v-else>
            <!-- <button class="mobile-nav-item" @click="$router.push('/user/requests')">
              <FileText :size="22" />
              <span>Solicitudes</span>
            </button> -->
            <button class="mobile-nav-item" @click="$router.push('/my-shipments')">
              <Route :size="22" />
              <span>Envíos</span>
            </button>
            <!-- <button class="mobile-nav-item" @click="$router.push('/pets')">
              <Dog :size="22" />
              <span>Mascotas</span>
            </button> -->
            <!-- <button class="mobile-nav-item" @click="toggleNotificationDropdown">
              <Bell :size="22" />
              <span>Avisos</span>
              <span v-if="unreadCount" class="mobile-badge">{{ unreadCount }}</span>
            </button> -->
            <button class="mobile-nav-item" @click="toggleDropdown">
              <img @error="onImageError" :src="personPhoto" class="mobile-nav-avatar">
              <span>Más</span>
            </button>
          </template>
        </template>

        <!-- Staff Navigation -->
        <template v-if="personType === 'Staff'">
          <template v-if="isAyvensRoute">
            <button class="mobile-nav-item" @click="$router.push('/staff/ayvens/contracts')">
              <FileText :size="22" />
              <span>Contratos</span>
            </button>
            <button class="mobile-nav-item" @click="toggleStaffActionsDropdown">
              <Clipboard :size="22" />
              <span>Operaciones</span>
            </button>
            <button class="mobile-nav-item" @click="toggleDropdown">
              <img @error="onImageError" :src="personPhoto" class="mobile-nav-avatar">
              <span>Más</span>
            </button>
          </template>
          <template v-else>
            <button class="mobile-nav-item" @click="toggleDropdown">
              <img @error="onImageError" :src="personPhoto" class="mobile-nav-avatar">
              <span>Más</span>
            </button>
          </template>
        </template>
      </template>

      <!-- Not Logged In -->
      <template v-else>
        <button class="mobile-nav-item" @click="$router.push('/login')">
          <LogIn :size="24" />
          <span>Entrar</span>
        </button>
        <button class="mobile-nav-item" @click="$router.push('/register')">
          <UserPlus :size="24" />
          <span>Registro</span>
        </button>
      </template>
    </div>

    <!-- Mobile Notifications Panel -->
    <div v-if="dropdownNotificationOpen" class="mobile-panel notifications-mobile">
      <div class="mobile-panel-overlay" @click="dropdownNotificationOpen = false"></div>
      <div class="mobile-panel-content">
        <div class="mobile-panel-header">
          <h6>Notificaciones</h6>
          <button @click="dropdownNotificationOpen = false" class="close-btn">
            <X :size="20" />
          </button>
        </div>
        <div class="notifications-list">
          <div v-if="notifications.length === 0" class="empty-state">
            <BellOff :size="40" />
            <p>No hay notificaciones nuevas</p>
          </div>
          <div 
            v-for="notification in sortedNotifications" 
            :key="notification.id" 
            class="notification-item"
            @click="handleNotificationClick(notification)"
          >
            <div class="notification-content">
              <div class="notification-header">
                <h6>{{ notification.title }}</h6>
                <span class="notification-time">{{ timeSince(notification.created_at) }}</span>
              </div>
              <p class="notification-body" v-html="formatNotificationBody(notification.body)"></p>
            </div>
          </div>
        </div>
        <button v-if="notifications.length > 0" @click="markAllAsRead" class="btn-mark-all">
          Marcar todas como leídas
        </button>
      </div>
    </div>

    <!-- Mobile Staff Operations Panel -->
    <div v-if="staffActionsDropdownOpen && personType === 'Staff' && isAyvensRoute" class="mobile-panel staff-actions-mobile">
      <div class="mobile-panel-overlay" @click="staffActionsDropdownOpen = false"></div>
      <div class="mobile-panel-content">
        <div class="mobile-panel-header">
          <h6>Operaciones</h6>
          <button @click="staffActionsDropdownOpen = false" class="close-btn">
            <X :size="20" />
          </button>
        </div>
        <div class="menu-list">
          <a class="menu-item" @click="navigateAndClose('/staff/ayvens/incidents')">
            <AlertTriangle :size="20" />
            <span>Incidencias</span>
            <ChevronRight :size="16" />
          </a>
          <a class="menu-item" @click="navigateAndClose('/staff/ayvens/maintenance')">
            <Wrench :size="20" />
            <span>Mantenimientos</span>
            <ChevronRight :size="16" />
          </a>
          <a class="menu-item" @click="navigateAndClose('/staff/ayvens/return-processes')">
            <Route :size="20" />
            <span>Devoluciones</span>
            <ChevronRight :size="16" />
          </a>
        </div>
      </div>
    </div>

    <!-- Mobile User Menu Panel -->
    <div v-if="dropdownOpen && userLogged" class="mobile-panel user-menu-mobile">
      <div class="mobile-panel-overlay" @click="dropdownOpen = false"></div>
      <div class="mobile-panel-content">
        <div class="mobile-panel-header">
          <div class="user-header">
            <img @error="onImageError" :src="personPhoto" class="user-avatar-large">
            <div class="user-header-info">
              <h6>{{ personName }}</h6>
              <span>{{ personType === 'User' ? 'Usuario' : personType === 'Partner' ? 'Colaborador' : 'Staff' }}</span>
            </div>
          </div>
          <button @click="dropdownOpen = false" class="close-btn">
            <X :size="20" />
          </button>
        </div>
        <div class="menu-list">
          <a class="menu-item" v-if="personType !== 'Staff'" @click="handleMenuClick(personType === 'Partner' ? '/partner/info' : '/user/info')">
            <User :size="20" />
            <span>Perfil</span>
            <ChevronRight :size="16" />
          </a>
        <template v-if="personType === 'User' && isAyvensRoute">
            <div class="menu-divider"></div>
            <div class="menu-section-label">Ayvens</div>
            <a class="menu-item" @click="handleMenuClick('/ayvens/return-process')">
              <Route :size="20" />
              <span>Devolución</span>
              <ChevronRight :size="16" />
            </a>
            <a class="menu-item" @click="handleMenuClick('/ayvens/contracts')">
              <FileCheck :size="20" />
              <span>Documentos</span>
              <ChevronRight :size="16" />
            </a>
            <a class="menu-item" @click="handleMenuClick('/ayvens/nps-survey')">
              <Tag :size="20" />
              <span>Opinión NPS</span>
              <ChevronRight :size="16" />
            </a>
          </template>
        <template v-if="personType === 'Staff' && isAyvensRoute">
          <div class="menu-divider"></div>
          <div class="menu-section-label">Ayvens</div>
          <a class="menu-item" @click="handleMenuClick('/staff/ayvens/documents')">
            <FileCheck :size="20" />
            <span>Documentos</span>
            <ChevronRight :size="16" />
          </a>
          <a class="menu-item" @click="handleMenuClick('/staff/ayvens/metrics')">
            <BarChart :size="20" />
            <span>Métricas</span>
            <ChevronRight :size="16" />
          </a>
        </template>
          <a class="menu-item" v-if="personType === 'Partner'" @click="handleMenuClick('/partner/availability')">
            <Calendar :size="20" />
            <span>Disponibilidad</span>
            <ChevronRight :size="16" />
          </a>
          <a class="menu-item" v-if="personType !== 'Staff'" @click="handleMenuClick(personType === 'Partner' ? '/partner/payments' : '/user/charges')">
            <CreditCard :size="20" />
            <span>Cuenta</span>
            <ChevronRight :size="16" />
          </a>
        <a class="menu-item" v-if="personType === 'Staff' && !isAyvensRoute" @click="handleMenuClick('/staff')">
            <Home :size="20" />
            <span>Dashboard</span>
            <ChevronRight :size="16" />
          </a>
          
          <!-- Sección de Roles (si tiene múltiples) -->
          <template v-if="hasMultipleRoles">
            <div class="menu-divider"></div>
            <div class="menu-section-label">Cambiar Rol</div>
            <a 
              v-for="role in availableRoles" 
              :key="role.type"
              class="menu-item role-item"
              :class="{ 'active': role.type.toLowerCase() === personType.toLowerCase() }"
              @click="role.type.toLowerCase() !== personType.toLowerCase() ? switchToRole(role.type) : null"
            >
              <div class="role-icon-small">
                <component :is="role.type === 'user' ? 'User' : role.type === 'partner' ? 'Truck' : 'Briefcase'" :size="20" />
              </div>
              <span>{{ role.label }}</span>
              <svg v-if="role.type.toLowerCase() === personType.toLowerCase()" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="check-icon"><polyline points="20 6 9 17 4 12"></polyline></svg>
            </a>
          </template>
          
          <div class="menu-divider"></div>
          <a class="menu-item logout" @click="userlogout()">
            <LogOut :size="20" />
            <span>Cerrar sesión</span>
          </a>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import auth from "@/logic/auth";
import { ShowAlert } from "@/logic/aux";
import req from "@/logic/req";
import { formatTextWithDates } from "@/utils/dateFormatter";
import { 
  Bell, BellOff, User, LogOut, Calendar, CreditCard, 
  ChevronDown, ChevronRight, X, Home, Route, Car, Dog,
  FileText, LogIn, UserPlus, Truck, Briefcase, Settings,
  FileCheck, AlertTriangle, BarChart, Clipboard, Tag, Wallet, Wrench,
  MoreHorizontal,
  Moon, Sun
} from 'lucide-vue-next';

export default {
  name: 'Headers',
  components: {
    Bell, BellOff, User, LogOut, Calendar, CreditCard,
    ChevronDown, ChevronRight, X, Home, Route, Car, Dog,
    FileText, LogIn, UserPlus, Truck, Briefcase, Settings,
    FileCheck, AlertTriangle, BarChart, Clipboard, Tag, Wallet, Wrench,
    MoreHorizontal,
    Moon, Sun
  },
  data() {
    return {
      dropdownOpen: false,
      notifications: [],
      unreadCount: 0,
      personType: '',
      personName: '',
      userLogged: '',
      personPhoto: '',
      current_travels: '',
      dropdownNotificationOpen: false,
      staffActionsDropdownOpen: false,
      pollingInterval: null,
      availableRoles: [],
      hasMultipleRoles: false,
      ayvensIsDarkMode: false, // Estado del tema Ayvens - FIJO en modo claro
    };
  },
  computed: {
    isAyvensRoute() {
      return this.$route.path === '/ayvens' ||
        this.$route.path.startsWith('/ayvens/') ||
        this.$route.path === '/staff/ayvens' ||
        this.$route.path.startsWith('/staff/ayvens/') ||
        this.$route.path.startsWith('/staff/fleet')
    },
    sortedNotifications() {
      return this.notifications.slice().sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    }
  },
  async created() {
    this.personType = await auth.getPersonType() || '';
    this.personName = await auth.getPersonName() || '';
    this.userLogged = await auth.getUserLogged() || '';
    this.personPhoto = await auth.getPhoto() || '';
    
    // Cargar roles disponibles
    const roles = await auth.getAvailableRoles();
    if (roles && roles.length > 1) {
      this.availableRoles = roles;
      this.hasMultipleRoles = true;
    }
    
    // Cargar preferencia de tema Ayvens
    await this.loadAyvensThemePreference();
    this.applyAyvensTheme();
    
    // if (this.userLogged) {
    //   await this.loadNotifications();
    //   
    //   this.pollingInterval = setInterval(() => {
    //     this.loadNotifications();
    //   }, 30000);
    // }
  },
  methods: {
    ShowAlert,
    onImageError(e) {
      e.target.src = require('@/assets/img/user.png')
    },
    async navigateToHome() {
      const personType = await auth.getPersonType();
      
      // Check if Ayvens tenant by multiple methods
      const isAyvens = this.isAyvensTenant();
      
      if (personType === 'Partner' && this.userLogged) {
        this.$router.push('/partner-home');
      } else if (personType === 'Staff' && this.userLogged) {
        if (isAyvens) {
          this.$router.push('/staff/ayvens'); // Ayvens Staff dashboard
        } else {
          this.$router.push('/staff');
        }
      } else if (this.userLogged) {
        if (isAyvens) {
          this.$router.push('/ayvens'); // Ayvens User home
        } else {
          this.$router.push('/');
        }
      } else {
        this.$router.push('/');
      }
    },
    isAyvensTenant() {
      // Method 1: Check current route (most reliable)
      if (this.$route.path.startsWith('/ayvens') || 
          this.$route.path.startsWith('/staff/ayvens')) {
        return true;
      }
      
      // Method 2: Check environment variable (if set in .env.local)
      if (process.env.VUE_APP_TENANT === 'ayvens') {
        return true;
      }
      
      // Method 3: Check localStorage (if tenant was stored during navigation)
      const storedTenant = localStorage.getItem('tenant');
      if (storedTenant === 'ayvens') {
        return true;
      }
      
      // Method 4: Check window location
      if (window.location.hostname.includes('ayvens') || 
          window.location.pathname.includes('ayvens')) {
        return true;
      }
      
      // Method 5: Check if user has navigated to ayvens before (session)
      const hasVisitedAyvens = sessionStorage.getItem('hasVisitedAyvens');
      if (hasVisitedAyvens === 'true') {
        return true;
      }
      
      // Method 6: Default fallback - if API is on port 6001, assume Ayvens for dev
      // (You can remove this in production)
      const apiUrl = process.env.VUE_APP_API_URL || '';
      if (apiUrl.includes('6001')) {
        // In development, default to Ayvens if API is on 6001
        // Set session storage to remember
        sessionStorage.setItem('hasVisitedAyvens', 'true');
        localStorage.setItem('tenant', 'ayvens');
        return true;
      }
      
      return false;
    },
    timeSince(date) {
      if (!date) return '';
      
      // Parse ISO 8601 UTC string - new Date() automatically converts to local timezone
      const now = new Date();
      const notificationDate = new Date(date);
      let seconds = Math.floor((now - notificationDate) / 1000);
      
      // Si los segundos son negativos, la notificación es muy reciente (dentro del mismo segundo)
      // o hay un pequeño desfase de reloj - tratarla como "ahora"
      if (seconds < 0) {
        return "ahora";
      }
      
      // Menos de 60 segundos - mostrar "ahora" o segundos
      if (seconds < 10) {
        return "ahora";
      }
      
      if (seconds < 60) {
        return seconds + " seg";
      }
      
      // Minutos (60-3599 segundos)
      const minutes = Math.floor(seconds / 60);
      if (minutes < 60) {
        return minutes + " min";
      }
      
      // Horas (3600-86399 segundos)
      const hours = Math.floor(seconds / 3600);
      if (hours < 24) {
        return hours + " h";
      }
      
      // Días (86400-2591999 segundos)
      const days = Math.floor(seconds / 86400);
      if (days < 30) {
        return days + " d";
      }
      
      // Meses (2592000-31535999 segundos)
      const months = Math.floor(seconds / 2592000);
      if (months < 12) {
        return months + (months === 1 ? " mes" : " meses");
      }
      
      // Años
      const years = Math.floor(seconds / 31536000);
      return years + (years === 1 ? " año" : " años");
    },
    // async getNotifications(){
    //   // Verificar si el usuario está autenticado antes de solicitar notificaciones
    //   const token = await auth.getToken();
    //   const isLogged = await auth.getUserLogged();
      
    //   if (!token || !isLogged) {
    //     console.log('Usuario no autenticado, omitiendo solicitud de notificaciones');
    //     return;
    //   }
      
    //   req.get('unread').then((res) => {
    //     this.notifications = res.data.notifications;
    //     this.current_travels = res.data.current_travels;
    //     const old_unread = this.unreadCount;
    //     this.unreadCount = this.notifications.length;
    //     if (this.unreadCount > old_unread) {
    //       console.log('New notifications: ' + this.unreadCount);
    //     }
    //     }).catch((error) => {
    //       console.log(error);
    //       // Si hay un error de autenticación (401), detener el polling
    //       if (error.response && error.response.status === 401) {
    //         console.log('Token inválido o expirado, deteniendo polling de notificaciones');
    //         if (this.pollingInterval) {
    //           clearInterval(this.pollingInterval);
    //           this.pollingInterval = null;
    //         }
    //       }
    //     });
    // },
    formatNotificationBody(body) {
      // Usar la utilidad de formateo de fechas UTC a hora local
      return formatTextWithDates(body);
    },
    toggleNotificationDropdown() {
      this.dropdownNotificationOpen = !this.dropdownNotificationOpen;
    },
    markAsRead(notificationIds){
      req.post('mark-as-read', {notificationIds})
        .then((res) => {
          console.log(res.data);
          // Filtrar las notificaciones marcadas como leídas
          this.notifications = this.notifications.filter(n => !notificationIds.includes(n.id));
          // Actualizar el contador de notificaciones no leídas
          this.unreadCount = this.notifications.length;
        }).catch((error) => {
          console.log(error);
        });
    },
    async handleNotificationClick(notification) {
      this.markAsRead([notification.id]);
      // El filtrado ya se hace en markAsRead(), no es necesario duplicarlo aquí
      window.location.href = notification.url;
    },
    async markAllAsRead() {
      const notificationIds = this.notifications.map(n => n.id);
      this.markAsRead(notificationIds);
      // Cerrar el panel de notificaciones después de marcar todas como leídas
      this.dropdownNotificationOpen = false;
    },
    formatDate(value) {
      if (!value) return '';
      const date = new Date(value); // Parse ISO 8601 UTC string
      const year = String(date.getFullYear()).slice(-2);
      const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
      const month = months[date.getMonth()];
      const day = String(date.getDate()).padStart(2, '0');
      return `${year} ${month} ${day}`;
    },
    userlogout() {
      auth.logout()
        .then((res) => {
          // Limpiar todas las variables de estado del usuario
          this.userLogged = '';
          this.personType = '';
          this.personName = '';
          this.personPhoto = '';
          this.notifications = [];
          this.unreadCount = 0;
          this.current_travels = '';
          this.dropdownOpen = false;
          this.dropdownNotificationOpen = false;
          
          // Limpiar el intervalo de polling de notificaciones
          if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
          }
          
          this.ShowAlert(
            ' Gracias por usar Ayvens. Hasta la próxima',
            '',
            res.status,
            '/'
          );
        }).catch((error) => {
          // Limpiar todas las variables de estado del usuario incluso en caso de error
          this.userLogged = '';
          this.personType = '';
          this.personName = '';
          this.personPhoto = '';
          this.notifications = [];
          this.unreadCount = 0;
          this.current_travels = '';
          this.dropdownOpen = false;
          this.dropdownNotificationOpen = false;
          
          // Limpiar el intervalo de polling de notificaciones
          if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
          }
          
          this.ShowAlert(
            'Error',
            error,
            error.status
          );
        });
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
      // Cerrar el dropdown de notificaciones si está abierto
      if (this.dropdownOpen) {
        this.dropdownNotificationOpen = false;
        this.staffActionsDropdownOpen = false;
      }
    },
    toggleStaffActionsDropdown() {
      this.staffActionsDropdownOpen = !this.staffActionsDropdownOpen;
      // Cerrar otros dropdowns
      if (this.staffActionsDropdownOpen) {
        this.dropdownOpen = false;
        this.dropdownNotificationOpen = false;
      }
    },
    navigateAndClose(route) {
      this.staffActionsDropdownOpen = false;
      this.dropdownOpen = false;
      this.dropdownNotificationOpen = false;
      this.$router.push(route);
    },
    handleMenuClick(route) {
      this.dropdownOpen = false;
      this.dropdownNotificationOpen = false;
      this.$router.push(route);
    },
    async switchToRole(roleType) {
      // Cerrar dropdown
      this.dropdownOpen = false;
      this.dropdownNotificationOpen = false;
      
      // Encontrar la información del rol seleccionado
      const roleInfo = this.availableRoles.find(r => r.type === roleType);
      
      if (!roleInfo) {
        this.ShowAlert('Error', 'No se pudo cambiar al rol seleccionado', 400);
        return;
      }
      
      // Actualizar el tipo de persona en el storage
      await auth.setPersonType(roleType.charAt(0).toUpperCase() + roleType.slice(1));
      await auth.setPersonName(roleInfo.name);
      await auth.setPhoto(roleInfo.img_url);
      
      // Actualizar las variables locales
      this.personType = roleType.charAt(0).toUpperCase() + roleType.slice(1);
      this.personName = roleInfo.name;
      this.personPhoto = roleInfo.img_url;
      
      // Recargar notificaciones para el nuevo rol
      // this.getNotifications();
      
      // Redirigir según el rol
      let redirectPath = '';
      if (roleType === 'user') {
        redirectPath = '/ayvens';
      } else if (roleType === 'partner') {
        redirectPath = '/partner-home';
      } else if (roleType === 'staff') {
        redirectPath = '/staff/ayvens';
      }
      
      // Determinar el label del rol en mayúsculas
      const roleLabel = roleType === 'user' 
        ? 'USUARIO' 
        : roleType === 'partner' 
          ? 'COLABORADOR' 
          : roleType.toUpperCase();
      
      // Mostrar toast notification moderna
      const Toast = this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', this.$swal.stopTimer)
          toast.addEventListener('mouseleave', this.$swal.resumeTimer)
        }
      });
      
      if (!roleInfo.name || roleInfo.name === '') {
        // Si no tiene nombre, redirigir a completar info
        const infoPath = roleType === 'user' ? '/user/info' : roleType === 'partner' ? '/partner/info' : '/staff/ayvens';
        Toast.fire({
          icon: 'info',
          title: 'Por favor completa tu información personal'
        });
        setTimeout(() => {
          this.$router.push(infoPath);
        }, 1000);
      } else {
        // Toast notification moderna para cambio de rol exitoso
        Toast.fire({
          icon: 'success',
          title: `Ahora eres ${roleLabel}`,
          text: roleInfo.name ? `Hola ${roleInfo.name}` : ''
        });
        
        // Redirigir después de un breve delay
        setTimeout(() => {
          this.$router.push(redirectPath);
        }, 1500);
      }
    },
    
    // Métodos para gestionar tema Ayvens
    async loadAyvensThemePreference() {
      // Siempre usar modo claro (light mode)
      this.ayvensIsDarkMode = false;
    },
    
    applyAyvensTheme() {
      if (this.isAyvensRoute) {
        if (this.ayvensIsDarkMode) {
          document.documentElement.classList.add('ayvens-dark-theme');
          document.documentElement.classList.remove('ayvens-light-mode');
          document.body.classList.add('ayvens-dark-theme');
          document.body.classList.remove('ayvens-light-mode');
          document.body.style.backgroundColor = '#0a0a0a';
        } else {
          document.documentElement.classList.remove('ayvens-dark-theme');
          document.documentElement.classList.add('ayvens-light-mode');
          document.body.classList.remove('ayvens-dark-theme');
          document.body.classList.add('ayvens-light-mode');
          document.body.style.backgroundColor = '#f8f9fa';
        }
      } else {
          document.documentElement.classList.remove('ayvens-dark-theme');
          document.documentElement.classList.add('ayvens-light-mode');
          document.body.classList.remove('ayvens-dark-theme');
          document.body.classList.add('ayvens-light-mode');
          document.body.style.backgroundColor = '#f8f9fa';
      }
    },
    
    async toggleAyvensTheme() {
      // Tema oscuro deshabilitado: forzar modo claro.
      this.ayvensIsDarkMode = false;
      const { storage } = await import('@/logic/storage');
      await storage.set('ayvens_dark_mode', this.ayvensIsDarkMode);
      this.applyAyvensTheme();
    }
  },
  async mounted(){
    // Verificar si el usuario tiene un token de autenticación
    const token = await auth.getToken();
    const isLogged = await auth.getUserLogged();
    
    // Detectar si estamos en Ayvens y guardar en storage
    if (this.$route.path.startsWith('/ayvens') || this.$route.path.startsWith('/staff/ayvens')) {
      sessionStorage.setItem('hasVisitedAyvens', 'true');
      localStorage.setItem('tenant', 'ayvens');
    }
    
    // if (token && isLogged) {
    //   this.getNotifications(); // Obtener notificaciones al montar el componente
    //   this.pollingInterval = setInterval(this.getNotifications, 180000); // Polling cada 3 minutos
    // } else {
    //   console.log('Usuario no autenticado, no se iniciará el polling de notificaciones');
    // }
  },
  watch: {
    '$route.path'(newPath) {
      // Aplicar tema cuando cambia la ruta
      this.applyAyvensTheme();
      
      // Detectar si navegamos a Ayvens y guardar en storage
      if (newPath.startsWith('/ayvens') || newPath.startsWith('/staff/ayvens')) {
        sessionStorage.setItem('hasVisitedAyvens', 'true');
        localStorage.setItem('tenant', 'ayvens');
      }
    }
  },
  beforeDestroy() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval); // Limpiar el intervalo al destruir el componente
    }
  }
}
</script>

<style scoped>
/* Estilos del componente Headers.vue */
/* Todos los estilos están centralizados en: src/styles/components/headers.scss */
@import '@/styles/components/headers.scss';
</style>